var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "toolbar",
        {
          attrs: {
            title: _vm.company.companyName + " : Load Transactions",
            extended: _vm.isMobile
          }
        },
        [
          _c(
            "v-layout",
            {
              attrs: { slot: _vm.isMobile ? "extension" : null },
              slot: _vm.isMobile ? "extension" : null
            },
            [
              _c(
                "v-toolbar-items",
                [
                  _vm._l(_vm.toolbarNavButtonsData, function(item, idx) {
                    return [
                      _c(
                        "v-btn",
                        {
                          key: "txn_toolbar_nav_" + idx,
                          staticClass: "toolbar-btn px-1",
                          attrs: {
                            flat: "",
                            small: "",
                            right: "",
                            to: { name: item.routeName }
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              staticClass: "align-center",
                              attrs: { column: "" }
                            },
                            [
                              _c("v-icon", [_vm._v(_vm._s(item.iconName))]),
                              _vm._v(" "),
                              _vm.loadingTransactions
                                ? _c("v-progress-linear", {
                                    staticClass: "mt-2 mb-0",
                                    attrs: {
                                      color: "white",
                                      indeterminate: true
                                    }
                                  })
                                : [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.count) +
                                        "\n              "
                                    )
                                  ]
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view", { attrs: { company: _vm.company } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1f45054", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1f45054","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Transactions/TransactionsPage.vue
// module id = null
// module chunks = 